import React, { useState } from 'react';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const [showPolicy, setShowPolicy] = useState(false);

    const togglePolicy = (event) => {
        event.preventDefault();
        setShowPolicy((value) => !value);
    };

    return (
        <footer className="footer">
            <div className="container">
                <p>&copy; {currentYear} Mixout Technologies Private Limited. All rights reserved.</p>

                <div className="footer-privacy-section">
                    <button
                        type="button"
                        onClick={togglePolicy}
                        className="privacy-toggle-link"
                        aria-expanded={showPolicy}
                        aria-controls="privacy-policy-text"
                    >
                        Privacy Policy {showPolicy ? '(Hide)' : '(Show)'}
                    </button>

                    {showPolicy && (
                        <div className="privacy-policy-content" id="privacy-policy-text">
                            <p><strong>Website privacy · Updated October 7, 2026</strong></p>
                            <p>Mixout Technologies Private Limited operates this informational website. If you contact us by email, we use the information you provide to respond to your message.</p>
                            <p>Our products have their own privacy policies: <a href="/autoraja/privacy">AutoRaja</a>, <a href="https://macdelta.app/privacy">MacDelta</a>, and <a href="https://studiocarto.com/privacy">Studio Carto</a>.</p>
                            <p>
                                We may disclose information when required by law, to protect our legal rights,
                                or to operate and secure our services with trusted service providers.
                            </p>
                            <p>
                                We use commercially reasonable steps to protect information, but no method of
                                storage or transmission is completely secure.
                            </p>
                            <p>
                                If our website or game links to third-party services, their privacy practices are
                                governed by their own policies.
                            </p>
                            <p>
                                We may revise this policy from time to time. Updated versions will be posted on
                                this website.
                            </p>
                            <p>
                                Contact: <a href="mailto:contact@mixout.in">contact@mixout.in</a>
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
